import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';

import FopRibbon from 'apps/fops/components/FopRibbon';
import ScribeLink from 'apps/scribe/ScribeLink';
import SectionType from 'apps/catalogue/models/SectionType';
import { FopContainerViewPreferenceShape } from 'apps/catalogue/types';
import { VIEW_TYPE_PREFERENCE_SHELF } from 'apps/catalogue/actions/catalogue';

import wa from 'apps/analytics/services/waEventEmitter';
import GraphicPageComponent, { getComponentId } from 'apps/analytics/components/GraphicPageComponent';

export default class FopBanner extends Component {
  static propTypes = {
    advertType: PropTypes.string,
    buttonLabel: PropTypes.string,
    docNo: PropTypes.number.isRequired,
    docVersionNo: PropTypes.number.isRequired,
    fopViewPreference: FopContainerViewPreferenceShape.isRequired,
    id: PropTypes.string,
    imageAlt: PropTypes.string,
    imageSrc: PropTypes.string.isRequired,
    isTwoFopsWidth: PropTypes.bool.isRequired,
    parentNo: PropTypes.number,
    parentVersionNo: PropTypes.number,
    url: PropTypes.string,
  };

  constructor(props) {
    super(props);

    this.state = {
      shouldFixFopView: undefined,
    };

    this.detectIfFopBannerViewIsBroken = this.detectIfFopBannerViewIsBroken.bind(this);
  }

  componentDidMount() {
    const { isTwoFopsWidth } = this.props;

    if (isTwoFopsWidth) {
      this.detectIfFopBannerViewIsBroken();
      window.addEventListener('resize', this.detectIfFopBannerViewIsBroken);
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return (
      this.props.docNo !== nextProps.docNo ||
      this.props.docVersionNo !== nextProps.docVersionNo ||
      this.props.fopViewPreference !== nextProps.fopViewPreference ||
      this.state.shouldFixFopView !== nextState.shouldFixFopView
    );
  }

  componentWillUnmount() {
    const { isTwoFopsWidth } = this.props;

    if (isTwoFopsWidth) {
      document.removeEventListener('resize', this.detectIfFopBannerViewIsBroken);
    }
  }

  sendClickAnalytics = () => {
    const { docNo, docVersionNo, parentNo, parentVersionNo } = this.props;

    wa.triggerPageEventWithDescription('Inspiration FOP clicked', {
      FROM_ADVERT_DOC_NO: docNo,
      FROM_ADVERT_DOC_VERSION_NO: docVersionNo,
      FROM_ADVERT_PARENT_DOC_NO: parentNo,
      FROM_ADVERT_PARENT_DOC_VERSION_NO: parentVersionNo,
      PAGE_COMPONENT_ID: `${wa.getPageViewId()}.${getComponentId(docNo, docVersionNo)}`,
    });
  };

  renderButton() {
    const { buttonLabel } = this.props;

    if (!buttonLabel || !buttonLabel.length) {
      return null;
    }

    return <span className="pr-fopBanner__button">{buttonLabel}</span>;
  }

  renderContent() {
    const { imageAlt, imageSrc, url } = this.props;

    const style = {
      backgroundImage: `url("${imageSrc}")`,
    };

    if (url) {
      return (
        <ScribeLink
          className="pr-fopBanner__img pr-fopBanner__img--link"
          style={style}
          title={imageAlt}
          to={url}
          onClick={this.sendClickAnalytics}
        >
          {this.renderButton()}
        </ScribeLink>
      );
    }

    return (
      <span
        className="pr-fopBanner__img pr-fopBanner__img--static"
        style={style}
        title={imageAlt}
      />
    );
  }

  shouldRender() {
    const { docNo, fopViewPreference, imageSrc } = this.props;

    return docNo && (fopViewPreference === VIEW_TYPE_PREFERENCE_SHELF) && imageSrc;
  }

  detectIfFopBannerViewIsBroken() {
    const { id } = this.props;

    const fopBannerNode = document.querySelector(`li#${id}`);
    const fopBannerAnyPreviousElement = fopBannerNode.previousSibling;
    /* if there is not previous element,
      the fop banner should be the first element in the shelf
      and it should not be any issue to fix
    */
    if (!fopBannerAnyPreviousElement) return null;

    /*
      it should be used the previous sibling for the logic below
      excluding 'prevExtPlaceholder'
    */
    const fopBannerPreviousElement =
      fopBannerAnyPreviousElement.id !== `${id}--prevExtPlaceholder` ?
        fopBannerAnyPreviousElement :
        fopBannerAnyPreviousElement.previousSibling;

    const {
      right: fopBannerPreviousElementRight,
      width: fopBannerPreviousElementWidth,
    } = fopBannerPreviousElement.getBoundingClientRect();

    const fopsShelfElement = document.querySelector('.fops-shelf');
    const fopsShelfRight = fopsShelfElement.getBoundingClientRect().right;

    const twoFopsWidthLength = fopBannerPreviousElementWidth * 2;
    const widthAfterThePreviousElement = fopsShelfRight - fopBannerPreviousElementRight;

    /*
    check if there is space for two-fops-width fop banner
    between its previous sibling and the end of the container
    */
    const isPreviousFopCloserThanTwoFopWidthToTheRight =
      widthAfterThePreviousElement < twoFopsWidthLength;

    const isPreviousFopTheLastOneInTheRow =
      fopsShelfRight - fopBannerPreviousElementRight < 1;

    /*
      'prevExtPlaceholder' should be displayed if
      there is not enought space for the banner and
      the previous sibling is not the last element in the row
    */
    const shouldFixFopView = isPreviousFopCloserThanTwoFopWidthToTheRight && !isPreviousFopTheLastOneInTheRow;

    return this.setState({
      shouldFixFopView,
    });
  }

  render() {
    if (!this.shouldRender()) {
      return null;
    }

    const { advertType, docNo, docVersionNo, id, isTwoFopsWidth, parentNo, parentVersionNo } = this.props;
    const { shouldFixFopView } = this.state;
    const sectionType = advertType === 'customFopSection' ? SectionType.ADVERT_ALT : SectionType.ADVERT;

    return (
      <Fragment>
        {shouldFixFopView &&
          <li id={`${id}--prevExtPlaceholder`} className="fops-item fops-item--external fops-item--externalPlaceholder">
            <FopRibbon idx={1} sectionType={sectionType} />
          </li>
        }
        <li id={`${id}`} className="fops-item fops-item--advert">
          <FopRibbon idx={0} sectionType={sectionType} />
          <section className={`pr-fopBanner${isTwoFopsWidth ? ' pr-fopBanner--doubleSize' : ''}`}>
            <div className="pr-fopBanner__content">
              <div className="pr-fopBanner__imgPlaceholder" />
              {this.renderContent()}
            </div>
          </section>
        </li>
        {isTwoFopsWidth &&
          <li className="fops-item fops-item--advert                  fops-item--advertPlaceholder">
            <FopRibbon idx={1} sectionType={sectionType} />
          </li>
        }
        <GraphicPageComponent
          docNo={docNo}
          docVersionNo={docVersionNo}
          parentNo={parentNo}
          parentVersionNo={parentVersionNo}
          description="INSPIRATION_FOP"
        />
      </Fragment>
    );
  }
}
